import React, { useEffect } from "react";
import { Form, Input, InputNumber } from "antd";
import svg153 from "../../../../assets/svg/svg153.svg";
import svg154 from "../../../../assets/svg/svg154.svg";

function AmountToPay({ amount, form }) {
  const editableAmount = Form.useWatch("editableAmount", form);
  const displayAmount = editableAmount || amount || 0;

  useEffect(() => {
    if (amount) {
      form.setFieldsValue({ editableAmount: amount });
    }
  }, [amount, form]);

  // Format the display amount with commas
  const formattedDisplayAmount = displayAmount
    ? displayAmount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : "0";

  return (
    <div className="rounded-[0.75rem] bg-white shadow-[0_0_0_1px_rgba(0,0,0,0.05)] p-[0.75rem] mt-[1rem]">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-[0.5rem] ">
          <div className="w-[1.5rem] h-[1.5rem] rounded-[0.375rem] bg-[#EDEDF1] flex items-center justify-center">
            <img src={svg153} alt="svg153" />
          </div>
          <span className="text-[#1E191B] font-[400] font-lexendS text-[1rem] leading-[1.5rem]">
            Amount to Pay
          </span>
        </div>

        <div className="flex items-center gap-[0.44rem] rounded-[624.9375rem] py-[0.125rem] px-[0.5rem] bg-[#EDEDF1]">
          <img src={svg154} alt="svg154" className="w-[0.75rem] h-[0.75rem]" />
          <span className="text-[#4F4770] text-[0.625rem] font-[500] leading-[0.9375rem] font-lexendS">
            Min 10
          </span>
        </div>
      </div>

      <div className="flex justify-between items-center mb-[0.75rem] mt-[1rem]">
        <div className="text-[#4F4770] font-lexendS text-[0.75rem] font-[400] leading-[1rem]">
          Total Amount
        </div>

        <div className="text-[#0F172A] font-lexendS text-[0.875rem] font-[500] leading-[1.5rem]">
          KES {formattedDisplayAmount}
        </div>
      </div>

      <Form.Item
        label="Amount (KES)"
        name="editableAmount"
        initialValue={amount}
        className="mt-[.88rem]"
        rules={[{ required: true, message: "Please enter amount" }]}
      >
        <InputNumber
          min={10}
          formatter={(value) =>
            `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
          }
          parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
          className="input flex"
        />
      </Form.Item>
    </div>
  );
}

export default AmountToPay;
